const FIBER_AID_1_GIG_PRODUCT_TYPE_ID = 'a65725c6-b3a3-465d-8764-58b9c275e432';

export const isFiberAidPlan = (productTypeId: string): boolean => {
  return productTypeId === FIBER_AID_1_GIG_PRODUCT_TYPE_ID;
};
